import { useEffect, useRef, useState } from 'react';
import { C, t } from '../../Dashboard/components/dashboardConstants';
import { IcoMapPin, IcoCalSm, IcoClock } from '../../Dashboard/components/DashboardIcons';
import { getBoardAccentBackground } from '../../../../api/boardApi';

function BoardMoveBadge({ board }) {
  const color = board.color || '#888896';
  return (
    <span style={{
      width: 24,
      height: 24,
      borderRadius: 8,
      background: board.accentBackground || getBoardAccentBackground(color),
      color,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      flexShrink: 0,
    }}>
      {board.emoji || board.icon || '📁'}
    </span>
  );
}

export default function ArchiveAuditionCard({ item, boards = [], currentBoardId = null, onRemove, onMove, onOpen }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [moveOpen, setMoveOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!menuRef.current?.contains(e.target)) {
        setMenuOpen(false);
        setMoveOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const movableBoards = boards.filter((board) => String(board.id) !== String(currentBoardId));

  return (
    <div style={{
      background: C.white, border: `1px solid ${C.g200}`,
      boxShadow: C.shadow, borderRadius: '20px',
      padding: '30px', display: 'flex', flexDirection: 'column', gap: '24px',
      cursor: item.castingId ? 'pointer' : 'default',
    }} onClick={() => item.castingId && onOpen?.(item.castingId)}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{ border: '1px solid #FFB517', borderRadius: '6px', padding: '9px', display: 'flex', alignItems: 'center' }}>
            <span style={{
              background: 'linear-gradient(101.37deg, #FFD92B 0.67%, #FFB517 65.65%)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
              fontSize: '14px', fontWeight: 600, letterSpacing: '-0.04em', fontFamily: 'Pretendard, sans-serif',
            }}>
              {item.category}
            </span>
          </div>
          <span style={t('14px', 400, C.sub)}>저장일 : {item.savedDate}</span>
        </div>
        <div ref={menuRef} style={{ position: 'relative', flexShrink: 0 }} onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            style={{ width: 32, height: 32, border: 'none', borderRadius: 8, background: 'rgba(255, 255, 255, 0.92)', cursor: 'pointer' }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="5" cy="12" r="1.5" fill={C.sub} />
              <circle cx="12" cy="12" r="1.5" fill={C.sub} />
              <circle cx="19" cy="12" r="1.5" fill={C.sub} />
            </svg>
          </button>
          {menuOpen && (
            <div style={{ position: 'absolute', top: 'calc(100% + 6px)', right: 0, minWidth: 170, background: C.white, border: `1px solid ${C.g200}`, borderRadius: 14, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', padding: '8px 14px', zIndex: 20 }}>
              {movableBoards.length > 0 && (
                <button type="button" onClick={() => setMoveOpen((prev) => !prev)} style={{ width: '100%', padding: '10px 0', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', ...t('14px', 500, C.bk) }}>
                  다른 보관함으로 이동
                </button>
              )}
              <button type="button" onClick={() => onRemove?.(item.id)} style={{ width: '100%', padding: '10px 0', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', ...t('14px', 500, '#EF4444') }}>
                삭제
              </button>
              {moveOpen && movableBoards.length > 0 && (
                <div style={{ marginTop: 6, paddingTop: 8, borderTop: `1px solid ${C.g200}`, display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {movableBoards.map((board) => (
                    <button
                      key={board.id}
                      type="button"
                      onClick={() => {
                        onMove?.(item, board.id);
                        setMoveOpen(false);
                        setMenuOpen(false);
                      }}
                      style={{ width: '100%', padding: '8px 0', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, ...t('13px', 400, C.sub) }}
                    >
                      <BoardMoveBadge board={board} />
                      {board.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <span style={t('24px', 600, C.bk)}>{item.title || '공고 제목 없음'}</span>
        <span style={t('16px', 400, C.sub)}>{item.company}</span>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {item.status && (
          <span style={{ padding: '6px 12px', borderRadius: '999px', background: '#F6F7FA', ...t('13px', 500, C.g500) }}>
            상태 {item.status}
          </span>
        )}
        {item.recruitmentCount != null && (
          <span style={{ padding: '6px 12px', borderRadius: '999px', background: '#FFF7E8', ...t('13px', 500, '#B45309') }}>
            지원자 {item.recruitmentCount}명
          </span>
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', rowGap: '10px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', paddingRight: '10px', marginRight: '10px', borderRight: `1px solid ${C.g200}` }}>
          <IcoMapPin />
          <span style={t('16px', 400, C.g500)}>{item.location}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', paddingRight: '10px', marginRight: '10px', borderRight: `1px solid ${C.g200}` }}>
          <IcoCalSm />
          <span style={t('16px', 400, C.g500)}>{item.deadline}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', paddingLeft: '10px' }}>
          <IcoClock />
          <span style={t('16px', 600, C.g500)}>{item.dday}</span>
        </div>
      </div>
    </div>
  );
}
